import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative h-[500px] md:h-[600px] flex items-center justify-center px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dynamic%20overhead%20view%20of%20colorful%20shopping%20bags%20and%20packaging%20supplies%20scattered%20on%20a%20warm%20terracotta%20colored%20surface%2C%20ribbons%20and%20tissue%20paper%20artistically%20arranged%2C%20dramatic%20top%20down%20lighting%2C%20ecommerce%20and%20unboxing%20concept%2C%20vibrant%20editorial%20photography%20with%20rich%20textures&width=1600&height=900&seq=cta-v2-bg&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-foreground-950/50"></div>

      <div className="relative z-10 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-white tracking-tight max-w-2xl mx-auto leading-tight">
          {t('cta.title')}
        </h2>
        <p className="mt-4 text-white/80 text-base md:text-lg max-w-lg mx-auto">
          {t('cta.subtitle')}
        </p>
        <a
          href="https://kaspreadsheet.com"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-3 mt-8 px-8 py-4 bg-foreground-950 text-white text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap group"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 flex-shrink-0">
            <i className="ri-shopping-bag-3-line text-base"></i>
          </span>
          <span>{t('cta.button')}</span>
          <span className="w-5 h-5 flex items-center justify-center group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform">
            <i className="ri-arrow-right-up-line text-base"></i>
          </span>
        </a>
      </div>
    </section>
  );
}